import styled, { css } from 'styled-components';

export const ButtonPlayWrap = styled.div(({ theme: { colors } }) => {
    return css`
      color: ${colors.base};
      width: 71px;
      height: 71px;
    }
  `;
});